// Environment configuration
// This file will be replaced during build based on the environment

const environment = {
  production: false,
  backendUrl: 'http://127.0.0.1:5000/',
  sellneticsUrl: 'http://localhost:4200/sellnetics-av18/login-request',
  appVersion: require('../../package.json').version,
  environment: 'development'
}

export default environment

